"use strict";

var faqWidget = function () {
  function initSlider() {
    var slickDefaultOptions = {
      infinite: false,
      adaptiveHeight: false,
      slidesToShow: 2,
      slidesToScroll: 2,
      responsive: [{
        breakpoint: 1100,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }]
    };
    var $faqPreviews = $('.faq-previews');

    if ($faqPreviews.length) {
      $faqPreviews.slick(slickDefaultOptions);
    }
  }

  function unbindHandlers() {
    $(document).off('change', '.faq-categories-select');
  }

  function bindHandlers() {
    $(document).on('change', '.faq-categories-select', function () {
      window.location = $(this).val();
    });
  }

  function init() {
    unbindHandlers();
    bindHandlers();
    initSlider();
  }

  return {
    init: init
  };
}();

$(document).ready(function () {
  faqWidget.init();
});